import React from 'react'
import delve from 'dlv'

import RelatedArticlesGrid from 'components/shared/RelatedArticlesGrid'
import Button from 'components/shared/Button'

import css from './styles.module.scss'

const RelatedArticlesWithIntro = ({
  articles,
  gradientHeader,
  intro,
  button,
  bottomLink,
  customCardProps,
  customCardComponent,
}) => {
  const url = delve(button, 'url')
  const text = delve(button, 'text')

  return (
    <div className={css.RelatedArticlesWithIntro}>
      <RelatedArticlesGrid
        singleColumnOnTablet={false}
        gradientHeader={gradientHeader}
        intro={intro}
        cards={articles}
        bottomLink={bottomLink}
        customCardComponent={customCardComponent}
        customCardProps={customCardProps}
      />
      {button && (
        <div className={css.buttonWrapper}>
          <Button
            className={css.button}
            theme="gray"
            href={url}
            shallow
            replace
            scroll={false}
          >
            {text}
          </Button>
        </div>
      )}
    </div>
  )
}

export default RelatedArticlesWithIntro
